<template>
    <div class="quick-reply">
        <el-dialog
            title="商品选择"
            :visible.sync="visible"
            width="80vw"
            top="10vh"
        >
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="商品名称">
                    <el-input v-model="formInline.key_word" size="small" placeholder="商品名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="onSearch">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table v-if="goodsList.length" v-loading="loading" border :data="goodsList" height="450" overflow="auto" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" align="center" />
                <el-table-column label="图片" align="center" prop="original_img" width="180">
                    <template #default="scope">
                        <el-image :src="scope.row.original_img" alt="" style="width: 50px; height: 50px;" :preview-src-list="[scope.row.original_img]" />
                    </template>
                </el-table-column>
                <el-table-column label="名称" align="center" prop="goods_name" :show-overflow-tooltip="true" />
                <el-table-column label="分类" align="center" prop="catname" :show-overflow-tooltip="true" />
                <el-table-column label="价格" align="center" prop="shop_price" :show-overflow-tooltip="true" />
            </el-table>
            <el-empty v-else :image-size="100"></el-empty>
            <div class="flex row-right m-t-20 m-b-20">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="pagination.total"
                    :current-page.sync="pagination.page"
                    @current-change="getLists()" 
                    style="text-align: center"
                    v-if="pagination.total*1"
                ></el-pagination>
            </div>
            <div slot="footer" class="flex row-center">
                <el-button size="small" @click="visible = false">取 消</el-button>
                <el-button type="primary" size="small" :disabled="selectGoods.length === 0" @click="handleConfirm">确 认 发 送</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
import { apiGoodsList } from '@/api/app'
import { getUrlParams } from '@/utils/util'
export default {
    name: 'GoodsPanel',

    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            goodsList: [],
            keyword: '',
            loading: false,
			
			/* 分页器 */
			pagination: {
				size: 15,
				page: 1,
				total: 0,
			},
            formInline: {
                key_word: ''
            },
            selectGoods: []
        }
    },
    computed: {
        visible: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
    },
    watch: {
        visible(val) {
            if (val) this.getLists()
        }
    },
    created() {},
    methods: {
        handleScroll() {},
        // 获取快捷回复列表
        getLists() {
            this.loading = true
			let { size, page, total} = this.pagination
            const option = getUrlParams()
            console.log('option', option)
            apiGoodsList({
                key_word: this.formInline.key_word,
				page: page,
				limit: size,
                goods_state: 1,
                orderby1: 'goods_id',
                orderby2: 'desc',
                pid: option.application_id,
                user_id: option.user_id,
                seller_id: option.seller_id
            }).then((res) => {
                this.goodsList = res.list
                this.pagination.total = Number(res.count)
                this.pagination.page = Number(res.page)
            }).finally(() => {
                this.loading = false
            })
        },
        handleConfirm() {
            if (!this.selectGoods.length) return this.$message.error('请选择商品')
            this.$emit('select', this.selectGoods[0])
            this.visible = false
        },
        onSearch() {
            this.getLists()
        },
        handleSelectionChange(val) {
            this.selectGoods = val
        }
    },
}
</script>


<style lang="scss" scoped>
.quick-reply {
    .scrollbars-contain {
        height: 400px;
        .reply-lists {
            padding: 10px 0;
            .reply-item {
                border-radius: 4px;
                background: #f9f9f9;
                padding: 10px 16px;
                font-size: 12px;
                color: #333;
                cursor: pointer;
                &:not(:last-of-type) {
                    margin-bottom: 10px;
                }
            }
        }
    }
}
</style>
